import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import axios from '../../../../_services/api/axios';
import withErrorHandler from '../../../../_hoc/withErrorHandler';
import * as actionCreators from '../../../../_store/actions/index';
import { getTranslate } from 'react-localize-redux';
import ReactTooltip from 'react-tooltip'
import * as FormHelpers from '../../../../_helpers/Form.js';

import { GreyBox, Modal, Button, BoxTitle, Flex, FlexColumn, InputRow, Input, Form, Text, Spacer, Toggle } from 'components'

class EditJobModal extends Component {
    defaultFormState = {
        job: {
            name : {
                state : false,
                message : false
            },
            orders : {
                state : false,
                message : false
            },
            pieces : {
                state : false,
                message : false
            },
            stitches : {
                state : false,
                message : false
            },
            colors : {
                state : false,
                message : false
            },
            color_changes : {
                state : false,
                message : false
            },
            trims : {
                state : false,
                message : false
            },
            cone_changes : {
                state : false,
                message : false
            },
            garment_handling : {
                state : false,
                message : false
            },
            hooping : {
                state : false,
                message : false
            },
            other_work : {
                state : false,
                message : false
            }
        },
        machine : {
            speed : {
                state : false,
                message : false
            },
            color_change_time : {
                state : false,
                message : false
            },
            bobbin_stitch_count : {
                state : false,
                message : false
            },
            bobbin_change_time : {
                state : false,
                message : false
            },
            stitches_next_thread_break : {
                state : false,
                message : false
            },
            thread_break_fixing_time : {
                state : false,
                message : false
            },
            hoop_change_time : {
                state : false,
                message : false
            },
            trimming_time : {
                state : false,
                message : false
            },
            cone_change_time : {
                state : false,
                message : false
            },
            maintenance_cost : {
                state : false,
                message : false                
            }
        }
    }
    defaultMessageState = {
        show : false,
        message : null
    }
    defaultFormJob = {
        name: this.props.state.job.details.name,
        orders: this.props.state.job.details.orders,
        pieces: this.props.state.job.details.pieces,
        stitches: this.props.state.job.details.stitches,
        colors: this.props.state.job.details.colors,
        color_changes: this.props.state.job.details.color_changes,
        trims: this.props.state.job.details.trims,
        cone_changes: this.props.state.job.details.cone_changes,
        garment_handling: this.props.state.job.details.garment_handling,
        hooping: this.props.state.job.details.hooping,
        other_work: this.props.state.job.details.other_work/60
    }
    defaultFormMachine = {
        speed: 0,
        color_change_time: 0,
        bobbin_stitch_count: 0,
        bobbin_change_time: 0,
        stitches_next_thread_break: 0,
        thread_break_fixing_time: 0,
        hoop_change_time: 0,
        trimming_time: 0,
        cone_change_time: 0,
        maintenance_cost: 0,
        apply_to_all_machines: false
    }
    constructor(props) {
        super(props);
        this.state = {
            form : {
                job: this.defaultFormJob,
                machine: this.defaultFormMachine
            },
            form_state: this.defaultFormState,
            message : this.defaultMessageState,
            modalOpen: true,
            tabs : [{
                name : this.props.translate('editjobmodal.tab_1.name'),
                active : true,
                batch : false
            },{
                name : this.props.translate('editjobmodal.tab_2.name'),
                active : false,
                batch : false
            }]
        }
    }
    componentDidMount = () => {
        if(this.props.state.job.details.Id) {
            this.props.onCalculatorJobMachineFetch(this.props.state.job.details.Id);
        }
    }
    componentWillUnmount = () => {
        this.props.onCalculatorJobMachineFetchReset();
        this.props.onCalculatorJobUpdateReset();
        this.props.onCalculatorJobMachineUpdateReset();
        this.props.onCalculatorJobDuplicateCheckReset();
    }
    componentDidUpdate = (prevProps, prevState, snapshot) => {
        if(prevProps.defaults !== this.props.defaults) {
            this.setState(prevState => ({
                ...prevState.tabs,
                tabs : [{
                    name : this.props.translate('editjobmodal.tab_1.name'),
                    active : true,
                    batch : false
                },{
                    name : this.props.translate('editjobmodal.tab_2.name'),
                    active : false,
                    batch : false
                }]
            }))            
        }
        //Handle if job fetched
        if(!prevProps.state.job.fetched && this.props.state.job.fetched) {
            this.props.onCalculatorJobMachineFetch(this.props.state.job.details.Id);
            //Fill out Form fields
            this.setState(prevState => ({
                form: {
                    ...prevState.form,
                    job: {
                        ...prevState.form.job,
                        name: this.props.state.job.details.name,
                        orders: this.props.state.job.details.orders,
                        pieces: this.props.state.job.details.pieces,
                        stitches: this.props.state.job.details.stitches,
                        colors: this.props.state.job.details.colors,
                        color_changes: this.props.state.job.details.color_changes,
                        trims: this.props.state.job.details.trims,
                        cone_changes: this.props.state.job.details.cone_changes,
                        garment_handling: this.props.state.job.details.garment_handling,
                        hooping: this.props.state.job.details.hooping,
                        other_work: this.props.state.job.details.other_work/60
                    }
                }
            }));
        }
        //Handle if machine fetched
        else if(!prevProps.state.machine.fetched && this.props.state.machine.fetched) {
            //Fill out form fields
            this.setState(prevState => ({
                form: {
                    ...prevState.form,
                    machine: {
                        ...prevState.form.machine,
                        speed: this.props.state.machine.details.settings.speed,
                        color_change_time: this.props.state.machine.details.settings.color_change_time,
                        bobbin_stitch_count: this.props.state.machine.details.settings.bobbin_stitch_count,
                        bobbin_change_time: this.props.state.machine.details.settings.bobbin_change_time,
                        stitches_next_thread_break: this.props.state.machine.details.settings.stitches_next_thread_break,
                        thread_break_fixing_time: this.props.state.machine.details.settings.thread_break_fixing_time,
                        hoop_change_time: this.props.state.machine.details.settings.hoop_change_time,
                        trimming_time: this.props.state.machine.details.settings.trimming_time,
                        cone_change_time: this.props.state.machine.details.settings.cone_change_time,
                        maintenance_cost: this.props.state.machine.details.settings.maintenance_cost,
                    }
                }
            }));
        }
        //Duplicate Check
        if(!prevProps.state.job.name_checked && this.props.state.job.name_checked) {
            this.setState(prevState => ({
                form_state : {
                    ...prevState.form_state,
                    job: {
                        ...prevState.form_state.job,
                        name : {
                            ...prevState.form_state.name,
                            state : this.props.state.job.name_available ? 'success' : 'error',
                            message : !this.props.state.job.name_available ? this.props.translate('editjobmodal.error.name_exists') : null
                        }
                    }
                }
            }));
        }
        if(this.props.state.job.updated) {
            this.props.onUpdated();
            this.props.onCalculatorJobUpdateReset();
            this.setState(prevState => ({
                message: {
                    show: true,
                    message: this.props.translate('editjobmodal.success.job.saved'),
                    type: "success"
                },
                form_state: this.defaultFormState
            }), () => {
                ReactTooltip.rebuild();
            });
        }
        else if(prevProps.state.job.error !== this.props.state.job.error) {
            if(this.props.state.job.error.length) {
                this.setState(prevState => ({
                    form_state: this.defaultFormState
                }), () => {
                    this.props.state.job.error.forEach((error, index) => {
                        if(this.state.form_state.job[error.source]) {
                            this.setState(prevState => ({
                                form_state : {
                                    ...prevState.form_state,
                                    job : {
                                        ...prevState.form_state.job,
                                        [error.source] : {
                                            state : 'error',
                                            message : this.props.translate('global.error.'+error.key.toLowerCase()+'.'+error.source.toLowerCase(),null,{missingTranslationMsg: error.message})
                                        }
                                    }
                                }
                            }))
                        }
                    })
                });
            }
            if(this.props.state.job.error.length === 1) {
                this.setState(prevState => ({
                    message: {
                        message: this.props.translate('editjobmodal.error.'+this.props.state.job.error[0].key.toLowerCase(),null,{missingTranslationMsg: this.props.translate('editjobmodal.error.default')}),
                        type: "error"
                    }
                }));

            }
            else {
                this.setState(prevState => ({
                    message: {
                        message: this.props.translate('editjobmodal.error.default'),
                        type: "error"
                    }
                }));
            }
        }

        if(this.props.state.machine.updated) {
            this.props.onUpdated();
            this.props.onCalculatorJobMachineUpdateReset();
            this.setState(prevState => ({
                message: {
                    show: true,
                    message: this.props.translate('editjobmodal.success.machine.saved'),
                    type: "success"
                }
            }));
            this.setState(prevState => ({
                form: {
                    ...prevState.form,
                    machine: {
                        ...prevState.form.machine,
                        apply_to_all_machines: false
                    }
                }
            }));
            this.setState(prevState => ({
                form_state: this.defaultFormState
            }));
        }
        else if(prevProps.state.machine.error !== this.props.state.machine.error) {
            if(this.props.state.machine.error.length) {
                this.setState(prevState => ({
                    form_state: this.defaultFormState
                }), () => {
                    this.props.state.machine.error.forEach((error, index) => {
                        if(this.state.form_state.machine[error.source]) {
                            this.setState(prevState => ({
                                form_state : {
                                    ...prevState.form_state,
                                    machine : {
                                        ...prevState.form_state.machine,
                                        [error.source] : {
                                            state : 'error',
                                            message : this.props.translate('global.error.'+error.key.toLowerCase()+'.'+error.source.toLowerCase(),null,{missingTranslationMsg: error.message})
                                        }
                                    }
                                }
                            }))
                        }
                    })
                });
            }
            if(this.props.state.machine.error.length === 1) {
                this.setState(prevState => ({
                    message: {
                        message: this.props.translate('editjobmodal.error.'+this.props.state.machine.error[0].key.toLowerCase(),null,{missingTranslationMsg: this.props.translate('editjobmodal.error.default')}),
                        type: "error"
                    }
                }));

            }
            else {
                this.setState(prevState => ({
                    message: {
                        message: this.props.translate('editjobmodal.error.default'),
                        type: "error"
                    }
                }));
            }
        }
    }

    onTabClickedHandler = (index) => {
        let tabs = [...this.state.tabs];

        tabs.map(function(tab, index){
            tab.active = false;
        })
        tabs[index].active = true;
        this.setState(prevState => ({
            tabs: tabs
        }), () => {
            ReactTooltip.rebuild();
        });
    }

    updateJobHandler = ( event ) => {
        event.preventDefault();
        if(FormHelpers.validateFields.apply(this,[['name','stitches','colors','color_changes','trims','cone_changes','orders','hooping','pieces','other_work','garment_handling'], 'job'])) {
            const formData = {
                name : this.state.form.job.name,
                orders: Number.parseInt(this.state.form.job.orders),
                pieces: Number.parseInt(this.state.form.job.pieces),
                stitches: Number.parseInt(this.state.form.job.stitches),
                colors: Number.parseInt(this.state.form.job.colors),
                color_changes: Number.parseInt(this.state.form.job.color_changes),
                trims: Number.parseInt(this.state.form.job.trims),
                cone_changes: Number.parseInt(this.state.form.job.cone_changes),
                garment_handling: Number.parseInt(this.state.form.job.garment_handling),
                hooping: Number.parseInt(this.state.form.job.hooping),
                other_work: Number.parseFloat(this.state.form.job.other_work)*60
            };
            this.setState(prevState => ({
                form_state: this.defaultFormState
            }));
            this.props.onCalculatorJobUpdate(this.props.state.job.details.Id,formData);
        }
        else {
            this.setState(prevState => ({
                message: {
                    show: true,
                    message: this.props.translate('jobnewpage.error.default'),
                    type: "error"
                }
            }));
        }
    }

    updateMachineHandler = ( event ) => {
        event.preventDefault();
        if(FormHelpers.validateFields.apply(this,[['speed','color_change_time','bobbin_stitch_count','bobbin_change_time','stitches_next_thread_break','thread_break_fixing_time','hoop_change_time','trimming_time','cone_change_time'], 'machine'])) {
            const formData = {
                speed: Number.parseInt(this.state.form.machine.speed),
                color_change_time: Number.parseInt(this.state.form.machine.color_change_time),
                bobbin_stitch_count: Number.parseInt(this.state.form.machine.bobbin_stitch_count),
                bobbin_change_time: Number.parseInt(this.state.form.machine.bobbin_change_time),
                stitches_next_thread_break: Number.parseInt(this.state.form.machine.stitches_next_thread_break),
                thread_break_fixing_time: Number.parseInt(this.state.form.machine.thread_break_fixing_time),
                hoop_change_time: Number.parseInt(this.state.form.machine.hoop_change_time),
                trimming_time: Number.parseInt(this.state.form.machine.trimming_time),
                cone_change_time: Number.parseInt(this.state.form.machine.cone_change_time),
                maintenance_cost: Number.parseInt(this.state.form.machine.maintenance_cost),
                apply_to_all_machines: this.state.form.machine.apply_to_all_machines
            }
            this.setState(prevState => ({
                form_state: this.defaultFormState
            }));
            this.props.onCalculatorJobMachineUpdate(this.props.state.job.details.Id,formData);
        }
        else {
            this.setState(prevState => ({
                message: {
                    show: true,
                    message: this.props.translate('jobnewpage.error.default'),
                    type: "error"
                }
            }));
        }
    }

    inputChangedHandlerJob= (event, inputIdentifier) => {
        let value = event.target.value;
        this.setState(prevState => ({
            form: {
                ...prevState.form,
                job: {
                ...prevState.form.job,
                [inputIdentifier]: value
                }
            }
        }));
    }

    inputChangedHandlerMachine= (event, inputIdentifier) => {
        let value = event.target.value;
        this.setState(prevState => ({
            form: {
                ...prevState.form,
                machine: {
                ...prevState.form.machine,
                [inputIdentifier]: value
                }
            }
        }));
    }

    inputChangedToggleMachine = (value, inputIdentifier) => {
        this.setState(prevState => ({
            form: {
                ...prevState.form,
                machine: {
                ...prevState.form.machine,
                [inputIdentifier]: value
                }
            }
        }));
    }

    onCloseModal = () => {
        this.setState(prevState => ({
            modalOpen: false
        }))
    }

    inputBlurredHandler = (event, inputIdentifier) => {
        let value = event.target.value;
        if(inputIdentifier === 'name') {
            if(value.length) {
                this.setState(prevState => ({
                    form_state : {
                        ...prevState.form_state,
                        job : {
                            ...prevState.form_state.job,
                            name : {
                                ...prevState.form_state.name,
                                state : 'loading'
                            }
                        }
                    }
                }));
                this.props.onCalculatorJobDuplicateCheck({name: value, id: this.props.state.job.details.Id});
            }
            else {
                this.setState(prevState => ({
                    form_state : {
                        ...prevState.form_state,
                        name : {
                            ...prevState.form_state.name,
                            state : false
                        }
                    }
                }));
            }
        }
        if(this.state.tabs[0].active) {
            FormHelpers.validateFields.apply(this,[[inputIdentifier], 'job']);
        }
        else {
            FormHelpers.validateFields.apply(this,[[inputIdentifier], 'machine']);
        }
        if(this.refs[inputIdentifier + "InputRow"]) {
            this.refs[inputIdentifier + "InputRow"].hideTooltip();
        }
    }
    inputFocusHandler = (event, inputIdentifier) => {
        if(this.refs[inputIdentifier + "InputRow"]) {
            this.refs[inputIdentifier + "InputRow"].showTooltip();
        }
    }

    render () {
        if(!this.state.modalOpen) {
            return (<Redirect to={'/jobs/'+this.props.state.job.details.Id}  />)
        }
        var showMessage;
        if(this.state.message.message) {
            showMessage = this.state.message
        }
        return (
            <Modal show={true}>
                <GreyBox outerMargin="true" tabs={this.state.tabs} closeIcon={this.onCloseModal} onTabClicked={this.onTabClickedHandler} cols="2" msg_inside={showMessage} title={this.props.translate('editjobmodal.title')} titleTheme="light">
                    {this.state.tabs[0].active ? (
                        <Form onSubmit={this.updateJobHandler}>
                            <Flex break="xs">
                                <FlexColumn col="2">
                                    <Flex break="m">
                                        <BoxTitle>{this.props.translate('editjobmodal.tab_1.box_title_design')}</BoxTitle>
                                        <Spacer height="15px" />
                                        <InputRow   label={this.props.translate('global.form.label.job.name')}
                                                    ref="nameInputRow"
                                                    state={this.state.form_state.job.name.state ? this.state.form_state.job.name.state : null} 
                                                    tip={this.state.form_state.job.name.message ? this.state.form_state.job.name.message : null}>
                                            <Input 
                                                identifier="name"
                                                ref="name"
                                                type="text"
                                                value={this.state.form.job.name}
                                                changed={this.inputChangedHandlerJob}
                                                blurred={this.inputBlurredHandler}
                                                focused={this.inputFocusHandler} 
                                                maxlength={50}
                                                isRequired={true}/>
                                        </InputRow>
                                        <InputRow   label={this.props.translate('global.form.label.job.stitches')}
                                                    ref="stitchesInputRow"
                                                    state={this.state.form_state.job.stitches.state ? this.state.form_state.job.stitches.state : null}
                                                    tip={this.state.form_state.job.stitches.message ? this.state.form_state.job.stitches.message : null}
                                                    hint={this.props.translate('global.help.job.stitches')}>
                                            <Input 
                                                identifier="stitches"
                                                ref="stitches"
                                                type="number"
                                                minValue={1}
                                                maxValue={999999}
                                                value={this.state.form.job.stitches}
                                                changed={this.inputChangedHandlerJob}
                                                blurred={this.inputBlurredHandler}
                                                focused={this.inputFocusHandler}
                                                isRequired={true} />
                                        </InputRow>
                                        <Flex break="xs">
                                            <InputRow   label={this.props.translate('global.form.label.job.colors')}
                                                        cols="2"
                                                        ref="colorsInputRow"
                                                        state={this.state.form_state.job.colors.state ? this.state.form_state.job.colors.state : null} 
                                                        tip={this.state.form_state.job.colors.message ? this.state.form_state.job.colors.message : null}
                                                        hint={this.props.translate('global.help.job.colors')}>
                                                <Input 
                                                    identifier="colors"
                                                    ref="colors"
                                                    type="number"
                                                    minValue={1}
                                                    maxValue={999}
                                                    value={this.state.form.job.colors}
                                                    changed={this.inputChangedHandlerJob}
                                                    blurred={this.inputBlurredHandler}
                                                    focused={this.inputFocusHandler}
                                                    isRequired={true} />
                                            </InputRow>
                                            <InputRow   label={this.props.translate('global.form.label.job.color_changes')}
                                                        cols="2"
                                                        ref="color_changesInputRow"
                                                        state={this.state.form_state.job.color_changes.state ? this.state.form_state.job.color_changes.state : null} 
                                                        tip={this.state.form_state.job.color_changes.message ? this.state.form_state.job.color_changes.message : null}
                                                        hint={this.props.translate('global.help.job.color_changes')}>
                                                <Input 
                                                    identifier="color_changes"
                                                    ref="color_changes"
                                                    type="number"
                                                    minValue={0}
                                                    maxValue={999}
                                                    value={this.state.form.job.color_changes}
                                                    changed={this.inputChangedHandlerJob}
                                                    blurred={this.inputBlurredHandler}
                                                    focused={this.inputFocusHandler}
                                                    isRequired={true} />
                                            </InputRow>
                                            <InputRow   label={this.props.translate('global.form.label.job.trims')}
                                                        cols="2"
                                                        ref="trimsInputRow"
                                                        state={this.state.form_state.job.trims.state ? this.state.form_state.job.trims.state : null} 
                                                        tip={this.state.form_state.job.trims.message ? this.state.form_state.job.trims.message : null}
                                                        hint={this.props.translate('global.help.job.trims')}>
                                                <Input 
                                                    identifier="trims"
                                                    ref="trims"
                                                    type="number"
                                                    minValue={0}
                                                    maxValue={999}
                                                    value={this.state.form.job.trims}
                                                    changed={this.inputChangedHandlerJob}
                                                    blurred={this.inputBlurredHandler}
                                                    focused={this.inputFocusHandler}
                                                    isRequired={true} />
                                            </InputRow>
                                            <InputRow   label={this.props.translate('global.form.label.job.cone_changes')}
                                                        cols="2"
                                                        ref="cone_changesInputRow"
                                                        state={this.state.form_state.job.cone_changes.state ? this.state.form_state.job.cone_changes.state : null} 
                                                        tip={this.state.form_state.job.cone_changes.message ? this.state.form_state.job.cone_changes.message : null}
                                                        hint={this.props.translate('global.help.job.cone_changes')}>
                                                <Input 
                                                    identifier="cone_changes"
                                                    ref="cone_changes"
                                                    type="number"
                                                    minValue={0}
                                                    maxValue={99}
                                                    value={this.state.form.job.cone_changes}
                                                    changed={this.inputChangedHandlerJob}
                                                    blurred={this.inputBlurredHandler}
                                                    focused={this.inputFocusHandler}
                                                    isRequired={true} />
                                            </InputRow>
                                        </Flex>
                                    </Flex>
                                </FlexColumn>
                                <FlexColumn col="2">
                                    <Flex break="m">
                                        <BoxTitle>{this.props.translate('editjobmodal.tab_1.box_title_job')}</BoxTitle>
                                        <Spacer height="15px" />
                                        <InputRow   label={this.props.translate('global.form.label.job.orders')}
                                                    cols="2"
                                                    ref="ordersInputRow"
                                                    state={this.state.form_state.job.orders.state ? this.state.form_state.job.orders.state : null} 
                                                    tip={this.state.form_state.job.orders.message ? this.state.form_state.job.orders.message : null}
                                                    hint={this.props.translate('global.help.job.orders')}>
                                            <Input 
                                                identifier="orders"
                                                ref="orders"
                                                type="number"
                                                minValue={1}
                                                maxValue={999999}
                                                value={this.state.form.job.orders}
                                                changed={this.inputChangedHandlerJob}
                                                blurred={this.inputBlurredHandler}
                                                focused={this.inputFocusHandler}
                                                isRequired={true} />
                                        </InputRow>
                                        <InputRow   label={this.props.translate('global.form.label.job.pieces')}
                                                    cols="2"
                                                    ref="piecesInputRow"
                                                    state={this.state.form_state.job.pieces.state ? this.state.form_state.job.pieces.state : null} 
                                                    tip={this.state.form_state.job.pieces.message ? this.state.form_state.job.pieces.message : null}
                                                    hint={this.props.translate('global.help.job.pieces')}>
                                            <Input 
                                                identifier="pieces"
                                                ref="pieces"
                                                type="number"
                                                minValue={1}
                                                maxValue={99999}
                                                value={this.state.form.job.pieces}
                                                changed={this.inputChangedHandlerJob}
                                                blurred={this.inputBlurredHandler}
                                                focused={this.inputFocusHandler}
                                                isRequired={true} />
                                        </InputRow>
                                        <InputRow   label={this.props.translate('global.form.label.job.hooping')}
                                                    cols="2"
                                                    unit={this.props.translate('global.units.seconds')}
                                                    ref="hoopingInputRow"
                                                    state={this.state.form_state.job.hooping.state ? this.state.form_state.job.hooping.state : null} 
                                                    tip={this.state.form_state.job.hooping.message ? this.state.form_state.job.hooping.message : null}
                                                    hint={this.props.translate('global.help.job.hooping')}>
                                            <Input 
                                                identifier="hooping"
                                                ref="hooping"
                                                type="number"
                                                minValue={0}
                                                maxValue={1200}
                                                value={this.state.form.job.hooping}
                                                changed={this.inputChangedHandlerJob}
                                                blurred={this.inputBlurredHandler}
                                                focused={this.inputFocusHandler}
                                                isRequired={true} />
                                        </InputRow>
                                        <InputRow   label={this.props.translate('global.form.label.job.garment_handling')}
                                                    cols="2"
                                                    unit={this.props.translate('global.units.seconds')}
                                                    ref="garment_handlingInputRow"
                                                    state={this.state.form_state.job.garment_handling.state ? this.state.form_state.job.garment_handling.state : null} 
                                                    tip={this.state.form_state.job.garment_handling.message ? this.state.form_state.job.garment_handling.message : null}
                                                    hint={this.props.translate('global.help.job.garment_handling')}>
                                            <Input 
                                                identifier="garment_handling"
                                                ref="garment_handling"
                                                type="number"
                                                minValue={0}
                                                maxValue={9999}
                                                value={this.state.form.job.garment_handling}
                                                changed={this.inputChangedHandlerJob}
                                                blurred={this.inputBlurredHandler}
                                                focused={this.inputFocusHandler}
                                                isRequired={true} />
                                        </InputRow>
                                        <InputRow   label={this.props.translate('global.form.label.job.other_work')}
                                                    unit={this.props.translate('global.units.minutes')}
                                                    ref="other_workInputRow"
                                                    state={this.state.form_state.job.other_work.state ? this.state.form_state.job.other_work.state : null} 
                                                    tip={this.state.form_state.job.other_work.message ? this.state.form_state.job.other_work.message : null}
                                                    hint={this.props.translate('global.help.job.other_work')}>
                                            <Input 
                                                identifier="other_work"
                                                ref="other_work"
                                                type="number"
                                                minValue={0}
                                                maxValue={9999}
                                                value={this.state.form.job.other_work}
                                                changed={this.inputChangedHandlerJob}
                                                blurred={this.inputBlurredHandler}
                                                focused={this.inputFocusHandler}
                                                isRequired={true}
                                                step="any"
                                                validationPattern="^\d*(\.\d{0,1})?$" />
                                        </InputRow>
                                    </Flex>
                                </FlexColumn>
                            </Flex>
                            <Flex reverse="m">
                                <Button data-cy="cancel-edit-job-btn" href={'/jobs/' + this.props.state.job.details.Id} theme="light" value={this.props.translate('editjobmodal.tab_2.secondary.label')} width="320px" />
                                <Button data-cy="save-job-information-edit-job-btn" value={this.props.translate('editjobmodal.tab_1.submit')} type="submit" width="320px" /> 
                            </Flex>
                        </Form>
                    ) : (
                        <Form onSubmit={this.updateMachineHandler}>
                            <Flex break="xs">
                                <BoxTitle>{this.props.translate('editjobmodal.tab_2.box_title',{machine: this.props.state.machine.details.name})}</BoxTitle>
                                <Text>{this.props.translate('editjobmodal.tab_2.box_text')}</Text>
                                <Spacer height="15px" />
                                <FlexColumn col="2">
                                    <Flex break="m">
                                        <InputRow   label={this.props.translate('global.form.label.machine.speed')} 
                                                    unit={this.props.translate('global.units.spm')} cols="2" 
                                                    ref="speedInputRow"
                                                    state={this.state.form_state.machine.speed.state ? this.state.form_state.machine.speed.state : null} 
                                                    tip={this.state.form_state.machine.speed.message ? this.state.form_state.machine.speed.message : null}
                                                    hint={this.props.translate('global.help.machine.speed')}>
                                            <Input 
                                                identifier="speed"
                                                ref="speed"
                                                type="number"
                                                minValue={1}
                                                maxValue={2000}
                                                value={this.state.form.machine.speed}
                                                changed={this.inputChangedHandlerMachine}
                                                blurred={this.inputBlurredHandler}
                                                focused={this.inputFocusHandler}
                                                isRequired={true} />
                                        </InputRow>
                                        <InputRow   label={this.props.translate('global.form.label.machine.color_change_time')}
                                                    unit={this.props.translate('global.units.seconds')} 
                                                    cols="2" 
                                                    ref="color_change_timeInputRow"
                                                    state={this.state.form_state.machine.color_change_time.state ? this.state.form_state.machine.color_change_time.state : null} 
                                                    tip={this.state.form_state.machine.color_change_time.message ? this.state.form_state.machine.color_change_time.message : null}
                                                    hint={this.props.translate('global.help.machine.color_change_time')}>
                                            <Input 
                                                identifier="color_change_time"
                                                ref="color_change_time"
                                                type="number"
                                                minValue={1}
                                                maxValue={1200}
                                                value={this.state.form.machine.color_change_time}
                                                changed={this.inputChangedHandlerMachine}
                                                blurred={this.inputBlurredHandler}
                                                focused={this.inputFocusHandler}
                                                isRequired={true} />
                                        </InputRow>
                                        <InputRow   label={this.props.translate('global.form.label.machine.hoop_change_time')}
                                                    unit={this.props.translate('global.units.seconds')} 
                                                    cols="2" 
                                                    ref="hoop_change_timeInputRow"
                                                    state={this.state.form_state.machine.hoop_change_time.state ? this.state.form_state.machine.hoop_change_time.state : null} 
                                                    tip={this.state.form_state.machine.hoop_change_time.message ? this.state.form_state.machine.hoop_change_time.message : null}
                                                    hint={this.props.translate('global.help.machine.hoop_change_time')}>
                                            <Input 
                                                identifier="hoop_change_time"
                                                ref="hoop_change_time"
                                                type="number"
                                                minValue={1}
                                                maxValue={1200}
                                                value={this.state.form.machine.hoop_change_time}
                                                changed={this.inputChangedHandlerMachine}
                                                blurred={this.inputBlurredHandler}
                                                focused={this.inputFocusHandler}
                                                isRequired={true} />
                                        </InputRow>
                                        <InputRow   label={this.props.translate('global.form.label.machine.trimming_time')}
                                                    unit={this.props.translate('global.units.seconds')} 
                                                    cols="2" 
                                                    ref="trimming_timeInputRow"
                                                    state={this.state.form_state.machine.trimming_time.state ? this.state.form_state.machine.trimming_time.state : null} 
                                                    tip={this.state.form_state.machine.trimming_time.message ? this.state.form_state.machine.trimming_time.message : null}
                                                    hint={this.props.translate('global.help.machine.trimming_time')}>
                                            <Input 
                                                identifier="trimming_time"
                                                ref="trimming_time"
                                                type="number"
                                                minValue={1}
                                                maxValue={1200}
                                                value={this.state.form.machine.trimming_time}
                                                changed={this.inputChangedHandlerMachine}
                                                blurred={this.inputBlurredHandler}
                                                focused={this.inputFocusHandler}
                                                isRequired={true} />
                                        </InputRow>
                                        <InputRow   label={this.props.translate('global.form.label.machine.cone_change_time')}
                                                    unit={this.props.translate('global.units.seconds')} 
                                                    cols="2" 
                                                    ref="cone_change_timeInputRow"
                                                    state={this.state.form_state.machine.cone_change_time.state ? this.state.form_state.machine.cone_change_time.state : null} 
                                                    tip={this.state.form_state.machine.cone_change_time.message ? this.state.form_state.machine.cone_change_time.message : null}
                                                    hint={this.props.translate('global.help.machine.cone_change_time')}>
                                            <Input 
                                                identifier="cone_change_time"
                                                ref="cone_change_time"
                                                type="number"
                                                minValue={1}
                                                maxValue={1200}
                                                value={this.state.form.machine.cone_change_time}
                                                changed={this.inputChangedHandlerMachine}
                                                blurred={this.inputBlurredHandler}
                                                focused={this.inputFocusHandler}
                                                isRequired={true} />
                                        </InputRow>
                                        <InputRow   label={this.props.translate('global.form.label.machine.bobbin_change_time')}
                                                    unit={this.props.translate('global.units.seconds')} 
                                                    cols="2" 
                                                    ref="bobbin_change_timeInputRow"
                                                    state={this.state.form_state.machine.bobbin_change_time.state ? this.state.form_state.machine.bobbin_change_time.state : null} 
                                                    tip={this.state.form_state.machine.bobbin_change_time.message ? this.state.form_state.machine.bobbin_change_time.message : null}
                                                    hint={this.props.translate('global.help.machine.bobbin_change_time')}>
                                            <Input 
                                                identifier="bobbin_change_time"
                                                ref="bobbin_change_time"
                                                type="number"
                                                minValue={1}
                                                maxValue={1200}
                                                value={this.state.form.machine.bobbin_change_time}
                                                changed={this.inputChangedHandlerMachine}
                                                blurred={this.inputBlurredHandler}
                                                focused={this.inputFocusHandler}
                                                isRequired={true} />
                                        </InputRow>
                                    </Flex>
                                </FlexColumn>
                                <FlexColumn col="2">
                                    <Flex break="m">
                                        <InputRow   label={this.props.translate('global.form.label.machine.bobbin_stitch_count')}
                                                    ref="bobbin_stitch_countInputRow"
                                                    state={this.state.form_state.machine.bobbin_stitch_count.state ? this.state.form_state.machine.bobbin_stitch_count.state : null} 
                                                    tip={this.state.form_state.machine.bobbin_stitch_count.message ? this.state.form_state.machine.bobbin_stitch_count.message : null}
                                                    hint={this.props.translate('global.help.machine.bobbin_stitch_count')}>
                                            <Input 
                                                identifier="bobbin_stitch_count"
                                                ref="bobbin_stitch_count"
                                                type="number"
                                                minValue={1}
                                                maxValue={100000}
                                                value={this.state.form.machine.bobbin_stitch_count}
                                                changed={this.inputChangedHandlerMachine}
                                                blurred={this.inputBlurredHandler}
                                                focused={this.inputFocusHandler}
                                                isRequired={true} />
                                        </InputRow>
                                        <InputRow   label={this.props.translate('global.form.label.machine.stitches_next_thread_break')}
                                                    ref="stitches_next_thread_breakInputRow"
                                                    state={this.state.form_state.machine.stitches_next_thread_break.state ? this.state.form_state.machine.stitches_next_thread_break.state : null} 
                                                    tip={this.state.form_state.machine.stitches_next_thread_break.message ? this.state.form_state.machine.stitches_next_thread_break.message : null}
                                                    hint={this.props.translate('global.help.machine.stitches_next_thread_break')}>
                                            <Input 
                                                identifier="stitches_next_thread_break"
                                                ref="stitches_next_thread_break"
                                                type="number"
                                                minValue={1}
                                                maxValue={999999}
                                                value={this.state.form.machine.stitches_next_thread_break}
                                                changed={this.inputChangedHandlerMachine}
                                                blurred={this.inputBlurredHandler}
                                                focused={this.inputFocusHandler}
                                                isRequired={true} />
                                        </InputRow>
                                        <InputRow   label={this.props.translate('global.form.label.machine.thread_break_fixing_time')} 
                                                    ref="thread_break_fixing_timeInputRow"
                                                    unit={this.props.translate('global.units.seconds')} state={this.state.form_state.machine.thread_break_fixing_time.state ? this.state.form_state.machine.thread_break_fixing_time.state : null} 
                                                    tip={this.state.form_state.machine.thread_break_fixing_time.message ? this.state.form_state.machine.thread_break_fixing_time.message : null}
                                                    hint={this.props.translate('global.help.machine.thread_break_fixing_time')}>
                                            <Input 
                                                identifier="thread_break_fixing_time"
                                                ref="thread_break_fixing_time"
                                                type="number"
                                                minValue={1}
                                                maxValue={1200}
                                                value={this.state.form.machine.thread_break_fixing_time}
                                                changed={this.inputChangedHandlerMachine}
                                                blurred={this.inputBlurredHandler}
                                                focused={this.inputFocusHandler}
                                                isRequired={true} />
                                        </InputRow>
                                    </Flex>
                                </FlexColumn>
                            </Flex>
                            <Spacer height="20px" />
                            <Flex break="xs">
                            <InputRow reverse={true} 
                                        label={this.props.translate('editjobmodal.tab_2.form.label.apply_to_all_machines')} 
                                        theme="light"
                                        cols="2"
                                        isRight="true"
                                        labelStyle="toggleLeft">
                                <Toggle 
                                    identifier="apply_to_all_machines"
                                    align="left"
                                    multiLine="true"
                                    value={this.state.form.machine.apply_to_all_machines}
                                    changed={this.inputChangedToggleMachine} />
                            </InputRow>
                            </Flex>
                            <Flex reverse="m">
                                <Button data-cy="cancel-production-parameter-edit-job-btn" href={'/jobs/' + this.props.state.job.details.Id} theme="light" value={this.props.translate('editjobmodal.tab_2.secondary.label')} width="320px" />
                                <Button data-cy="save-production-parameter-edit-job-btn" value={this.props.translate('editjobmodal.tab_2.submit')} type="submit" width="320px" /> 
                            </Flex>
                        </Form>
                    ) }
                </GreyBox>
            </Modal>
        )
    }
}

const mapStateToProps = state => {
    return {
        defaults: state.defaults,
        state: state.calculatorJob,
        translate: getTranslate(state.locale),
        settingsCompany: state.calculatorSettingsCompany
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onCalculatorJobMachineFetch: (id) => dispatch(actionCreators.calculatorJobMachineFetch(id)),
        onCalculatorJobMachineFetchReset: (id) => dispatch(actionCreators.calculatorJobMachineFetchReset(id)),
        onCalculatorJobUpdate: (id, formData) => dispatch(actionCreators.calculatorJobUpdate(id, formData)),
        onCalculatorJobUpdateReset: () => dispatch(actionCreators.calculatorJobUpdateReset()),
        onCalculatorJobMachineUpdate: (id, formData) => dispatch(actionCreators.calculatorJobMachineUpdate(id, formData)),
        onCalculatorJobMachineUpdateReset: () => dispatch(actionCreators.calculatorJobMachineUpdateReset()),
        onCalculatorJobDuplicateCheck: (formData) => dispatch(actionCreators.calculatorJobDuplicateCheck(formData)),
        onCalculatorJobDuplicateCheckReset: () => dispatch(actionCreators.calculatorJobDuplicateCheckReset())
    }
};
export default connect(mapStateToProps, mapDispatchToProps)(withErrorHandler(EditJobModal, axios));



// WEBPACK FOOTER //
// ./src/components/pages/JobPage/EditJobModal/index.js